import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../../services/analytics';

/**
 * Fires a PostHog pageview on every SPA route change. Mounted once inside
 * <BrowserRouter> in App.tsx — capture_pageview is off in analytics.ts
 * because CRA/react-router navigation doesn't trigger a real page load.
 */
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    analytics.pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
